// Briefly highlight a quote row after it's replaced by a Turbo Stream, so the
// live month-by-month refresh (Airbnb server-side, VRBO from the extension) is
// visible as progress. Only fires on stream renders — not the initial load —
// and is scoped to quote rows so other Turbo Streams aren't affected.

function flash(el) {
  el.classList.remove("row-flash");
  void el.offsetWidth; // force reflow so the animation restarts on repeat updates
  el.classList.add("row-flash");
  el.addEventListener("animationend", () => el.classList.remove("row-flash"), {
    once: true,
  });
}

document.addEventListener("turbo:before-stream-render", (event) => {
  const stream = event.target;
  if (stream.getAttribute("action") !== "replace") return;

  const targetId = stream.getAttribute("target");
  if (!targetId || !targetId.startsWith("quote_row_")) return;

  const defaultRender = event.detail.render;
  event.detail.render = async (streamElement) => {
    await defaultRender(streamElement);
    const el = document.getElementById(targetId);
    if (el) flash(el);
  };
});
